import CreateNewFolderOutlined from "@mui/icons-material/CreateNewFolderOutlined";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import DriveFileMoveOutlined from "@mui/icons-material/DriveFileMoveOutlined";
import DriveFileRenameOutline from "@mui/icons-material/DriveFileRenameOutline";
import LinkOutlined from "@mui/icons-material/LinkOutlined";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { toast } from "react-hot-toast";

interface CustomTreeItemMenuProps {
  menuOpen: boolean;
  menuAnchor: HTMLElement | null;
  onMenuOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMenuClose: () => void;
  onRename: () => void;
  onGetSharingLink: () => string;
  onCreateSubFolder: () => void;
  onArchive: () => void;
  onMove: () => void;
}

export const CustomTreeItemMenu = ({
  menuOpen,
  menuAnchor,
  onMenuOpen,
  onMenuClose,
  onRename,
  onGetSharingLink,
  onCreateSubFolder,
  onArchive,
  onMove,
}: CustomTreeItemMenuProps): React.ReactElement => (
  <>
    <IconButton
      size="small"
      className="folder-menu-button"
      onClick={onMenuOpen}
      aria-label="Folder actions"
      data-analytics-id="content-library-folder-menu"
    >
      <MoreHoriz fontSize="small" />
    </IconButton>
    <Menu
      open={menuOpen}
      anchorEl={menuAnchor}
      onClose={onMenuClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{ paper: { sx: { minWidth: 200 } } }}
    >
      <MenuItem
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onRename();
        }}
      >
        <ListItemIcon>
          <DriveFileRenameOutline fontSize="small" />
        </ListItemIcon>
        <ListItemText>Rename</ListItemText>
      </MenuItem>
      <MenuItem onClick={onCreateSubFolder}>
        <ListItemIcon>
          <CreateNewFolderOutlined fontSize="small" />
        </ListItemIcon>
        <ListItemText>Create sub-folder</ListItemText>
      </MenuItem>
      <MenuItem
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          const shareLink = onGetSharingLink();
          void navigator.clipboard?.writeText(shareLink);
          toast.success("Link copied to clipboard");
          onMenuClose();
        }}
      >
        <ListItemIcon>
          <LinkOutlined fontSize="small" />
        </ListItemIcon>
        <ListItemText>Get sharing link</ListItemText>
      </MenuItem>
      <MenuItem
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onMove();
        }}
      >
        <ListItemIcon>
          <DriveFileMoveOutlined fontSize="small" />
        </ListItemIcon>
        <ListItemText>Move</ListItemText>
      </MenuItem>
      <MenuItem
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onArchive();
        }}
      >
        <ListItemIcon>
          <DeleteOutlined fontSize="small" sx={{ color: "error.main" }} />
        </ListItemIcon>
        <ListItemText sx={{ color: "error.main" }}>Archive</ListItemText>
      </MenuItem>
    </Menu>
  </>
);
